var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{class:_vm.classes},[_c('ul',[(_vm.rootDirectory)?_c('directory',{attrs:{"resource":_vm.rootDirectory}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }